import * as React from 'react';
import { SVGProps } from 'react';

const SvgDoubleCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22.06 7.06 12.03 17.092l-2.09-2 1.06-1.06 1.03.939L21 6l1.06 1.06ZM16.53 7.06 6.5 17.092 2 12.531l1.06-1.061 3.44 3.5L15.47 6l1.06 1.06Z'
      fill='#000'
    />
  </svg>
);

export default SvgDoubleCheck;
